import React from 'react'
import { createBottomTabNavigator, BottomTabNavigationOptions } from '@react-navigation/bottom-tabs'
// Config
import { useScreenOptionsForTabs } from 'APP/Nav/ScreenOptions'
// Hooks & Services
import useScreenView from 'APP/Hooks/useScreenView'
import { usePrimaryTabs } from './useTabs'

type TabNavItem = {
  name: string
  component: React.ComponentType
  options?: BottomTabNavigationOptions
}

const Tab = createBottomTabNavigator()

export const TabBar = ({ isSmallScreen = false, tabs = [] as TabNavItem[] }) => {
  const screenOptions = useScreenOptionsForTabs() as BottomTabNavigationOptions

  return (
    <Tab.Navigator
      screenOptions={screenOptions}
      initialRouteName={tabs?.[0]?.name}
      /* When not on a small screen, prevent default tabBar render,
      as side menu will be present. */
      tabBar={isSmallScreen ? undefined : () => null}
    >
      {tabs?.map((navItem) => (
        <Tab.Screen key={navItem.name} {...navItem} />
      ))}
    </Tab.Navigator>
  )
}

export const TabBarScreen = () => {
  const { isSmallScreen } = useScreenView()
  const primaryTabs = usePrimaryTabs()

  return <TabBar isSmallScreen={isSmallScreen} tabs={primaryTabs} />
}
